import React from 'react';
import { Award, Target, Users } from 'lucide-react';
import '../styles/about.css';

const About = () => {
  const stats = [
    { icon: Award, label: 'GPA', value: '9.5+' },
    { icon: Target, label: 'Projects', value: '5+' },
    { icon: Users, label: 'Hackathons', value: '3+' }
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="section-header">
          <h2 className="section-title">About Me</h2>
          <div className="section-divider"></div>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p className="about-paragraph">
              I'm a second-year <strong>Artificial Intelligence</strong> student at Babeș-Bolyai University 
              with a passion for building impactful technology. With a perfect 10.00 GPA in my first semester 
              and a strong academic foundation, I combine theoretical knowledge with hands-on development experience 
              across mobile, web, and AI applications.
            </p>
            <p className="about-paragraph">
              As a <strong>founder and co-founder</strong>, I've launched innovative projects including 
              <strong> Reflectify</strong> (an AI app combating elderly loneliness that reached Innovation Labs 
              semifinals), <strong>AI Academy</strong> (a Duolingo-style AI learning platform), 
              <strong> TransylvaniaTrivia</strong> (a weekly quiz event with automated presentation tools), 
              and a <strong>Chess AI Application</strong> with intelligent opponents and post-game analysis. 
              My technical expertise spans <strong>Python, C++, Java, Flutter, React, and TypeScript</strong>, 
              complemented by experience in AI/ML, database design, and full-stack development. I hold 
              <strong>HackerRank certifications</strong> in Python and Problem Solving, along 
              with <strong>Cambridge C2</strong> English certification.
            </p>
            <p className="about-paragraph">
              Beyond coding, I've represented <strong>Team Romania</strong> in volleyball for 10 years, 
              earning national medals and competing at the FISU World University Games in beach volleyball. 
              This athletic background has instilled discipline, leadership, and teamwork skills that enhance 
              my approach to software development. I'm constantly seeking new challenges where I can merge 
              technical innovation with real-world impact.
            </p>
          </div>

          <div className="about-stats">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div key={index} className="stat-card">
                  <div className="stat-icon">
                    <Icon size={28} />
                  </div>
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;